import ReportsPage from "../../../components/settings/reports/ReportsPage"

export default ReportsPage